import LoginScreen from '@screens/Login/LoginScreen';

export default LoginScreen;
